import * as React from "react";
import { styled } from "@mui/system";
import MUIButton from "@mui/material/Button";
import { FIC_BUTTON_SIZES } from "./_ficStyle";
import { VAPORLIGHT_BUTTON_SIZES } from "./_vaporLightStyle";
import {
  ButtonProps as ButtonPropsMUI,
  ButtonTypeMap
} from "@mui/material/Button";
import { ExtendButtonBase } from "@mui/material/ButtonBase";
export interface ButtonProps extends ButtonPropsMUI {
  component?: React.ElementType;
}

const ButtonRoot = styled(MUIButton, {
  name: "Button",
  slot: "Root",
  overridesResolver: (props, styles) => [styles.root]
})(({ theme }) => {
  // switch (theme.name) {
  //   case "fic":
  //     return { ...FIC_BUTTON_SIZES };
  //   default:
  //     return { ...VAPORLIGHT_BUTTON_SIZES };
  // } keep as example
  return { ...VAPORLIGHT_BUTTON_SIZES };
});

export const Button = React.forwardRef<HTMLButtonElement, ButtonPropsMUI>(
  function Button(props, ref) {
    return <ButtonRoot {...props} ref={ref} />;
  }
);
